/** Kentucky / user CIP status that means the owner is still in manual review. */
export const CIP_REVIEW_STATUS = "manual_review";

/** True when the cash-deposit owner must not proceed past splash. */
export const isCipInReview = (cipStatus?: string | null): boolean =>
  cipStatus === CIP_REVIEW_STATUS;
